import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Badge, Button, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  FaChartLine,
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaVideo,
} from "react-icons/fa";

import slider1 from "../assets/slider1.png";
import slider2 from "../assets/slider2.png";
import slider3 from "../assets/slider3.png";
import slider4 from "../assets/slider4.png";
import slider5 from "../assets/slider5.png";
import profileImage from "../assets/Profile.jpg";
import reportFile from "../assets/report.pdf"; // Add your report file


const PoliticalLeader = () => {
  const [showVideoModal, setShowVideoModal] = useState(false);
  const videos = [
    "https://www.youtube.com/watch?v=vikas",
    "https://www.youtube.com/watch?v=vikas&t=99s",
    "https://www.youtube.com/watch?v=vikasvikas",
    "https://www.youtube.com/watch?v=vikas&t=11s",
    "https://www.youtube.com/watch?v=vikas",
    "https://www.youtube.com/watch?v=vikas"
  ];

  const getYouTubeID = (url) => {
    const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };

  // Handle download
  const handlePdfview = () => {

    if (reportFile) {
      window.open(reportFile, '_blank'); // Opens PDF in new tab instantly
    } else {
      console.error('PDF file not found.');
    }

  };

  // Handle view video
  const handleViewVideo = () => {
    setShowVideoModal(true);
  };

  // Handle close video modal
  const handleCloseVideoModal = () => {
    setShowVideoModal(false);
  };

  // fade animation on scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("fade-in");
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll(".fade-on-scroll").forEach((el) => observer.observe(el));
  }, []);

  return (
    <div style={{ fontFamily: "'Roboto', sans-serif", lineHeight: 1.6 }}>

      <section className="position-relative overflow-hidden" style={{ maxHeight: '600px ' }}>
        <div className="d-flex w-100 animate-slider">
          {[slider1, slider2, slider3, slider4, slider5].map((img, idx) => (
            <div key={idx} className="flex-shrink-0 w-100 position-relative">
              {/* Bootstrap aspect ratio container */}
              <div className="ratio" style={{ aspectRatio: "16 / 9" }}>
                <img
                  src={img}
                  alt={`Slide ${idx + 1}`}

                  style={{ backgroundColor: "#000", maxHeight: '600px' }}
                />
              </div>
            </div>
          ))}
        </div>
      </section>


      {/* Profile Section */}
      <Container className="my-2 fade-on-scroll" style={{ fontFamily: "'Poppins', sans-serif" }}>
        <div className="d-flex justify-content-center align-items-center mb-3 p-3 bg-light rounded-3 shadow-sm flex-wrap gap-3 text-center">
          <Button
            variant="danger"
            className="fw-bolder mb-0 text-white"
            style={{ color: "#C21807" }}  // टेक्स्ट लाल रंग में
            onClick={handlePdfview}
          >
            विकाश कुमार माली का संकल्प पत्र
          </Button>
          <Button
            className="btn zoom-btn"
            style={{
              backgroundColor: "#28a745",  // हरा रंग
              color: "#fff",
              fontWeight: "bold",
              padding: "0.5rem 1rem",
              borderRadius: "0.5rem",
              border: "none"
            }}
            download
            onClick={handlePdfview}
          >
            डाउनलोड करें
          </Button>
        </div>


        <Card className="border-0 rounded-4 overflow-hidden mx-auto profile-card bg-light shadow-sm">
          <Row className="g-0 align-items-center">

            {/* Left Section */}
            <Col md={4} className="text-center border-end p-4 profilesection" >
              <img
                src={profileImage}
                alt="Arun Singh"
                className="img-fluid rounded-4 mb-4 profile-img"
                style={{ maxWidth: "300px", marginBottom: "1.5rem", height: '500px' }}
              />
              <h4
                className="fw-bold mb-1"
                style={{ color: "#C21807", fontFamily: "'Merriweather', serif" }}
              >
                विकाश कुमार माली
              </h4>
              <p className="text-muted mb-2" style={{ fontSize: "0.95rem" }}>
                सचिव,समाजसेवी,समाज सुधारक
              </p>
              <div className="mb-3 d-none">
                {/* <Badge bg="success" className="me-2 fs-6">सक्रिय नेता</Badge> */}
                <Badge bg="danger" className="fs-6">CPI (ML)</Badge>
              </div>
              <blockquote
                className="fst-italic text-secondary small"
                style={{ fontFamily: "'Merriweather', serif" }}
              >
                “सच्चा नेतृत्व सेवा और साथ देने में है।”
              </blockquote>
            </Col>

            {/* Right Section */}
            <Col md={8} className="p-4">
              <Card.Body>
                <div
                  className="text-secondary"
                  style={{
                    fontSize: "1.05rem",
                    lineHeight: "1.8",
                    textAlign: "justify",
                    whiteSpace: "pre-line",
                  }}
                >
                  <strong style={{ color: "red" }}>
                    विकाश कुमार माली  | संघर्ष और सेवा के प्रतिबिंब
                  </strong>
                  {"\n"}

                  श्री विकास कुमार माली एक कर्मठ, संवेदनशील एवं जमीनी स्तर पर सक्रिय समाजसेवी हैं, जो पिछले 14 वर्षों से अधिक समय से सामाजिक कुरीतियों के विरुद्ध निरंतर संघर्ष कर रहे हैं।
                  उनका जीवन उद्देश्य समाज में फैली बाल विवाह, दहेज प्रथा एवं कन्या भ्रूण हत्या जैसी अमानवीय प्रथाओं को समाप्त करना तथा बेटियों को सम्मान, सुरक्षा और समान अधिकार दिलाना है।
                  उन्होंने समाज सेवा को केवल विचार नहीं, बल्कि व्यवहार में उतारते हुए हजारों गरीब, अनाथ एवं असहाय बेटियों के जीवन में सकारात्मक बदलाव लाने का कार्य किया है।{"\n\n"}

                  <strong style={{ color: "red" }}>संस्था का परिचय</strong>{"\n"}
                  कन्या विवाह एंड विकास सोसाइटी एक गैर-लाभकारी सामाजिक संस्था है, जो भारत सरकार के विधानांतर्गत बिहार सरकार द्वारा मान्यता प्राप्त है।
                  संस्था का कार्य क्षेत्र सम्पूर्ण भारत है, जिसमें बिहार एवं झारखंड प्रमुख रूप से शामिल हैं।
                  संस्था की स्थापना समाज में बेटियों के प्रति सकारात्मक सोच विकसित करने और सामाजिक न्याय को मजबूत करने के उद्देश्य से की गई है।{"\n\n"}

                  <strong style={{ color: "red" }}>संस्था के उद्देश्य</strong>{"\n"}
                  बाल विवाह एवं दहेज प्रथा की रोकथाम{"\n"}
                  कन्या भ्रूण हत्या पर नियंत्रण{"\n"}
                  दहेज-मुक्त सामूहिक विवाह को बढ़ावा{"\n"}
                  बेटियों की शिक्षा, सुरक्षा व सम्मान{"\n"}
                  महिला सशक्तिकरण व सामाजिक जागरूकता{"\n\n"}

                  <strong style={{ color: "red" }}>प्रमुख उपलब्धियाँ</strong>{"\n"}
                  13,000+ निर्धन व असहाय कन्याओं का सम्मानपूर्वक विवाह{"\n"}
                  बिहार-झारखंड में सामूहिक विवाह आयोजन{"\n"}
                  विवाह सामग्री व आवश्यक वस्तुओं का निःशुल्क वितरण{"\n"}
                  प्रशासन व समाज कल्याण विभाग का सहयोग{"\n\n"}

                  <strong style={{ color: "red" }}>अभियान व सम्मान</strong>{"\n"}
                  दहेज विरोधी व बाल विवाह रोकथाम अभियान{"\n"}
                  बेटी बचाओ-बेटी पढ़ाओ में सक्रिय भागीदारी{"\n"}
                  “Shining Star of Bihar Award” से सम्मानित{"\n\n"}

                  <strong style={{ color: "red" }}>भविष्य की योजना</strong>{"\n"}
                  महिला प्रशिक्षण व स्वावलंबन केंद्र{"\n"}
                  बालिकाओं हेतु निःशुल्क शिक्षा व आत्मरक्षा प्रशिक्षण{"\n"}
                  सेनेटरी पैड निर्माण-वितरण व बालिका संसद{"\n\n"}


                  <strong style={{ color: "red" }}>संदेश</strong>{"\n"}
                  “बाल विवाह भविष्य का विनाश है,{"\n"}
                  कन्या भ्रूण हत्या मानवता पर अपराध है।{"\n"}
                  दहेज प्रथा समाज का कलंक है,{"\n"}
                  आइए, मिलकर बेटियों का सम्मान और भविष्य सुरक्षित करें।”

                </div>
              </Card.Body>

            </Col>
          </Row>
        </Card>

      </Container>


      <Container
        className="my-5 fade-on-scroll py-5 animated-section"
        style={{
          borderRadius: "20px",
          fontFamily: "'Poppins', sans-serif",
        }}
      >
        <h2
          className="fw-bold text-center text-danger mb-3"
          style={{
            fontSize: "2.5rem",
            position: "relative",
            display: "inline-block",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          विकाश कुमार माली का <span style={{ color: "#C21807" }}>संकल्प पत्र</span>

          <span
            style={{
              display: "block",
              width: "80px",
              height: "5px",
              backgroundColor: "#C21807",
              borderRadius: "2px",
              margin: "10px auto 0",
            }}
          ></span>
        </h2>

        <Row className="g-4 justify-content-center mt-4">
          {/* Report Card */}
          <Col md={5}>
            <Card
              className="border-0 h-100 text-center p-4 animated-card"
              style={{
                backgroundColor: "white",
                border: "2px solid #f8d7da",
                borderRadius: "15px",
                transition: "all 0.3s ease-in-out",
              }}
            >
              <Card.Body>
                <FaChartLine
                  size={50}
                  className="text-danger mb-3 animated-icon"
                />
                <Card.Title
                  className="fw-bold mb-3"
                  style={{ fontSize: "1.6rem" }}
                >
                  विकाश कुमार माली का संकल्प पत्र
                </Card.Title>
                <Card.Text
                  className="text-secondary mb-4"
                  style={{ fontSize: "1.05rem", lineHeight: "1.7" }}
                >
                  विकास कार्यों, जनकल्याण पहल और प्रदर्शन रिकॉर्ड की पूरी जानकारी प्राप्त करें।
                </Card.Text>
                <Button
                  variant="danger"
                  className="px-5 py-2 fw-semibold custom-button"
                  onClick={handlePdfview}
                >
                  Download
                </Button>
                <p className="info-note mt-3" style={{ fontSize: "0.95rem" }}>
                  📄 यहाँ क्लिक करें और विकाश कुमार माली का संकल्प पत्र डाउनलोड करें।
                </p>
              </Card.Body>
            </Card>
          </Col>

          {/* Report Video */}
          <Col md={5}>
            <Card
              className="border-0 h-100 text-center p-4 animated-card"
              style={{
                backgroundColor: "white",
                border: "2px solid #f8d7da",
                borderRadius: "15px",
                transition: "all 0.3s ease-in-out",
              }}
            >
              <Card.Body>
                <FaVideo
                  size={50}
                  className="text-danger mb-3 animated-icon"
                />
                <Card.Title
                  className="fw-bold mb-3"
                  style={{ fontSize: "1.6rem" }}
                >
                  विकाश कुमार माली का संकल्प पत्र वीडियो 
                </Card.Title>
                <Card.Text
                  className="text-secondary mb-4"
                  style={{ fontSize: "1.05rem", lineHeight: "1.7" }}
                >
                  आकर्षक दृश्य प्रस्तुतियों के माध्यम से कार्यक्रम हाइलाइट्स, सामुदायिक संपर्क और सार्वजनिक बैठकों का अन्वेषण करें।
                </Card.Text>
                <Button
                  variant="danger"
                  className="px-5 py-2 fw-semibold custom-button"
                  onClick={handleViewVideo}
                >
                  View
                </Button>
                <p className="info-note mt-3" style={{ fontSize: "0.95rem" }}>
                  🎥 यहाँ क्लिक करें और विकाश कुमार माली का संकल्प पत्र का  रिपोर्ट देखें।
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>


      {/* Video Modal */}
      <Modal
        show={showVideoModal}
        onHide={handleCloseVideoModal}
        fullscreen
        centered
        className="video-modal"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fs-5">Report Video</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="ratio ratio-16x9 w-100 h-100">
            <iframe
              src="https://www.youtube.com/embed/vikashkumar"
              title="Report Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              style={{ width: "100%", height: "100%" }}
            ></iframe>
          </div>
        </Modal.Body>
      </Modal>


      {/* Social Media Section */}
      <Container className="my-5 fade-on-scroll">
        <h2
          className="fw-bold text-center text-danger mb-4"
          style={{ fontSize: "2rem" }}
        >
          Social Media
        </h2>
        <Row className="g-4 justify-content-center">
          {[
            {
              icon: <FaFacebook size={32} color="#1877F2" />,
              title: "Follow on Facebook",
              src: "https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3Dpfbid0Hz8SSNBwDtPp7uDW8UY3fzXdJzr17pvvYmDJ5aedkwTa4VV9AWzktP1rwvbcujpbl%26id%3D61587383810243&show_text=true&width=500",
              link: "https://www.facebook.com/profile.php?id=61587383810243",
            },
            {
              icon: <FaInstagram size={32} color="#E4405F" />,
              title: "Follow on Instagram",
              src: "https://www.instagram.com/vikashkumarmaligarhwa/embed",
              link: "https://www.instagram.com/vikashkumarmaligarhwa/"
            },
            {
              icon: <FaYoutube size={32} color="#FF0000" />,
              title: "Follow on YouTube",
              src: "https://www.youtube.com/embed/0BqXt7Q2GCk",
              link: "https://www.youtube.com/@arunsinghmla" // your actual channel link
            }
          ].map((item, idx) => (
            <Col md={4} key={idx}>
              {/* ✅ Make the whole card clickable */}
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <Card className="border-0 shadow-sm text-center p-3 hover-card">
                  <Card.Body>
                    <h4
                      className="fw-bold mb-3 d-flex justify-content-center align-items-center gap-2"
                      style={{ fontSize: "1.25rem" }}
                    >
                      {item.icon} {item.title}
                    </h4>

                    <iframe
                      width="100%"
                      height="400"
                      src={item.src}
                      title={item.title}
                      frameBorder="0"
                      className="rounded"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    ></iframe>
                  </Card.Body>
                </Card>
              </a>
            </Col>
          ))}
        </Row>
      </Container>



      {/* More Information Section */}

      <Container className="my-5 py-5 fade-on-scroll bg-gradient-light rounded-4">
        {/* Section Header */}
        <div className="text-center mb-5">
          <div className="bg-danger bg-opacity-10 rounded-3 p-4 d-inline-block mb-3">
            <FaYoutube size={48} className="text-danger mb-3" />
            <h2 className="fw-bold display-5 text-dark mb-2">
              View Some More Videos
            </h2>
          </div>
          <p className="lead text-muted mx-auto" style={{ maxWidth: "600px" }}>
          विकाश कुमार माली के नवीनतम भाषणों और जन-संपर्क गतिविधियों का अन्वेषण करें
          </p>
        </div>

        <Row className="g-4 justify-content-center">
          {videos.map((videoUrl, index) => (
            <Col md={6} lg={4} key={index}>
              <Card className="border-0 shadow rounded-4 overflow-hidden h-100 hover-shadow">
                <div className="position-relative">
                  <div className="ratio ratio-16x9">
                    <iframe
                      src={`https://www.youtube.com/embed/${getYouTubeID(videoUrl)}`}
                      title={`Arun Singh Speech ${index + 1}`}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className="rounded-top-4"
                      style={{ border: "none" }}
                    ></iframe>
                  </div>
                </div>


              </Card>
            </Col>
          ))}
        </Row>

      </Container>


      {/* Footer */}
      <footer className="bg-danger text-white text-center py-4 mt-5 footer">
        <Container>
          <p className="mb-2 fw-bold">© {new Date().getFullYear()} Vikas Kumar Mali </p>
          <div className="mt-2 d-flex justify-content-center gap-3">
            <a href="https://www.facebook.com/profile.php?id=61587383810243" target="_blank" rel="noopener noreferrer" className="text-white">
              <FaFacebook size={24} />
            </a>
            <a href="https://www.instagram.com/vikashkumarmaligarhwa/" target="_blank" rel="noopener noreferrer" className="text-white">
              <FaInstagram size={24} />
            </a>
            <a href="https://www.youtube.com/@arunsinghmla" target="_blank" rel="noopener noreferrer" className="text-white">
              <FaYoutube size={24} />
            </a>
          </div>
        </Container>
      </footer>

      {/* Animations & Styles */}
      <style>{`
        @keyframes slide {
          0%, 20% { transform: translateX(0); }
          25%, 45% { transform: translateX(-100%); }
          50%, 70% { transform: translateX(-200%); }
          75%, 95% { transform: translateX(-300%); }
          100% { transform: translateX(-400%); }
        }
        .animate-slider { animation: slide 20s infinite linear; }
        .hero-text h1 { animation: fadeInUp 1.5s ease forwards; opacity:0; }
        .hero-text p { animation: fadeInUp 2s ease forwards; opacity:0; }
        @keyframes fadeInUp { 0% { transform: translateY(20px); opacity:0;} 100% { transform: translateY(0); opacity:1;} }
        .profile-card:hover { transform: translateY(-5px); transition: all 0.3s; }
        .profile-img:hover { transform: scale(1.05); transition: all 0.3s; }
        .achievement-card { transition: all 0.3s; }
        .achievement-card:hover { transform: scale(1.05); box-shadow: 0 10px 20px rgba(0,0,0,0.2); }
        .hover-card { transition: all 0.3s; }
        .hover-card:hover { transform: translateY(-5px); box-shadow: 0 10px 20px rgba(0,0,0,0.2); }
        .fade-on-scroll { opacity:0; transform: translateY(30px); transition: all 0.8s ease; }
        .fade-on-scroll.fade-in { opacity:1; transform: translateY(0); }
        .footer a:hover { color: #ffd6d6; transition: 0.3s; }
        
        /* Video Modal Styles */
        .video-modal .modal-content {
          max-height: 70vh;
        }
        .video-modal .modal-body {
          padding: 0;
        }
        .video-modal .ratio-16x9 {
          height: 400px;
        }
        @keyframes gradientShift {
  0% { background: linear-gradient(135deg, #fff5f5, #ffeaea); }
  50% { background: linear-gradient(135deg, #ffeaea, #fff0f0); }
  100% { background: linear-gradient(135deg, #fff5f5, #ffeaea); }
}

@keyframes pulseIcon {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.1); opacity: 0.9; }
  100% { transform: scale(1); opacity: 1; }
}

@keyframes borderGlow {
  0% { border-color: #f8d7da; }
  50% { border-color: #C21807; }
  100% { border-color: #f8d7da; }
}

.animated-section {
  animation: gradientShift 6s ease-in-out infinite;
}

.animated-card {
  animation: borderGlow 4s ease-in-out infinite;
}

.animated-icon {
  animation: pulseIcon 3s ease-in-out infinite;
}

.info-note {
  font-size: 0.9rem;
  color: #C21807;
  font-style: italic;
  margin-top: 8px;
}
@keyframes zoomInOut {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

.zoom-btn {
  animation: zoomInOut 1.5s infinite;
}
@media (min-width: 992px) {
  .profilesection {
    margin-bottom: 45%;
  }
}
.custom-button {
  border-radius: 30px;
  font-size: 1.1rem;
  transition: all 0.3s ease;
}

.custom-button:hover {
  background-color: green !important; 
  border-color: green !important;     
}
      `}</style>
    </div>
  );
};

export default PoliticalLeader;